// Module
var code = "<p>User agents represent a digital &quot;name tag&quot; that identifies what software, operating system, and browser configuration a given event (e.g. click) occurred with.</p> <p>For example: <code>Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:124.0) Gecko/20100101 Firefox/124.0</code></p> ";
// Exports
export default code;